import React, { useEffect, useState } from "react";
// import PropTypes from 'prop-types';
import InputStyles from "../InputStyles";
import { generateRandomString } from "../../../utils/helpers";

const containsNonWhiteSpaceRegex = /.*\S.*/;

const validateText = (value) => {
  // test the input is not only whitespace
  return containsNonWhiteSpaceRegex.test(value) && value.trim().length > 0
    ? true
    : "Please include a non-whitespace character.";
};

const Textarea = ({
  label,
  register,
  formState: { errors = {} } = {},
  fieldName,
  placeholder,
  required,
  errorMessage,
  maxLength = "250",
  pattern = {
    value: containsNonWhiteSpaceRegex,
    message: `Please include a non-whitespace character.`,
  },
  validate,
  helperText,
}) => {
  const [inputLength, setInputLength] = useState(0);

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  const inputRandomId = isClient
    ? `${fieldName}-${generateRandomString()}`
    : null;

  const reg = register(fieldName, {
    required: required ? errorMessage || `${label} is required` : false,
    pattern,
    validate: validate ? validate : validateText,
  });

  return (
    <InputStyles>
      <div className="label-container">
        <div>
          <label
            htmlFor={inputRandomId}
            dangerouslySetInnerHTML={{ __html: label }}
          />
          {required && <span className="required-asterisk">*</span>}
        </div>
        <div className="helper-text-container">
          {helperText && <span className="helper-text">{helperText}</span>}
          {maxLength && (
            <span className="label__max-char">
              ({inputLength}/{maxLength})
            </span>
          )}
        </div>
      </div>
      <textarea
        type="text"
        id={fieldName}
        maxLength={maxLength}
        className={`${errors[fieldName] ? "error" : ""}`}
        {...reg}
        placeholder={placeholder}
        onChange={(e) => {
          reg.onChange(e); // ← triggers validation
          setInputLength(e.target.value.length);
        }}
      />
      {errors[fieldName] && (
        <span className="input-error">
          {errors[fieldName]?.message || errorMessage}
        </span>
      )}
    </InputStyles>
  );
};
export default Textarea;

// Textarea.propTypes = {
//     register: PropTypes.func.isRequired,
//     fieldName: PropTypes.string.isRequired,
//     label: PropTypes.string.isRequired,
//     required: PropTypes.bool,
//     formState: PropTypes.object,
//     placeholder: PropTypes.string,
//     errorMessage: PropTypes.string,
//     helperText: PropTypes.string,
//     maxLength: PropTypes.string,
// };
